import React from 'react';
import PropTypes from 'prop-types';

import Seats from './seats';
import { ZoneSelector } from '@weezevent/throne';

import HoverZone from '../../components/placement/hoverZone';

import { useMousePosition } from '../../utils/hooks';
import { useTranslation } from 'react-i18next';

import { computeContingentSales, computeCategorySales } from '../../helpers/contingentSales';

export function SeatMap({ availability, contingents, rates = [], sync = () => {}, onBack = () => {}, onZoneSelected = () => {}, onSeatsSelected = () => {} }) {
    const { x, y } = useMousePosition();
    const [hoveredZone, setHoveredZone] = React.useState(null);
    const _onSeatsSelected = React.useCallback(
        seats => {
            if (!Array.isArray(seats)) {
                seats = [seats];
            }

            onSeatsSelected(seats);
        },
        [onSeatsSelected]
    );

    if (!availability) {
        return null;
    }

    if (!availability.seats?.length) {
        // Show zone selector if no seats in response
        return (
            <React.Fragment>
                {hoveredZone && <HoverZone mouseX={x} mouseY={y} zone={hoveredZone} />}
                <ZoneSelector
                    zone={availability}
                    onZoneSelected={onZoneSelected}
                    onZoneOver={setHoveredZone}
                    onBackButtonClicked={onBack}
                    showAvailability={false}
                    defaultColor="#0033fa"
                    unavailableColor={false}
                    type="list"
                />
            </React.Fragment>
        );
    }

    return <Seats availability={availability} contingents={contingents} rates={rates} onSeatsSelected={_onSeatsSelected} onBack={onBack} onContingentChanged={sync} />;
}

SeatMap.propTypes = {
    availability: PropTypes.object.isRequired,
    contingents: PropTypes.array.isRequired,
    rates: PropTypes.array.isRequired,
    sync: PropTypes.func,
    onBack: PropTypes.func,
    onZoneSelected: PropTypes.func,
    onZoneOver: PropTypes.func,
    onSeatsSelected: PropTypes.func
};

export function ContingentQuota({ organization, event, contingents, availability, inventory }) {
    const { t } = useTranslation();

    if (!availability || !contingents?.length) {
        return null;
    }

    let contingentComponents = computeContingentSales({
        availability,
        mainContingents: contingents,
        inventory,
        organization,
        event
    });

    if (!contingentComponents?.length) {
        return t('ticket.availability.no_contingents');
    }

    return <ul className="contingent vertical">{contingentComponents}</ul>;
}

export function CategoryQuota({ organization, event, categories, availability, inventory }) {
    const { t } = useTranslation();

    if (!availability || !categories?.length) {
        return null;
    }

    let contingentComponents = computeCategorySales({
        availability,
        categories,
        inventory,
        organization,
        event
    });

    if (!contingentComponents?.length) {
        return t('ticket.availability.no_categories');
    }

    return <ul className="contingent vertical">{contingentComponents}</ul>;
}

ContingentQuota.propTypes = {
    organization: PropTypes.object.isRequired,
    event: PropTypes.object.isRequired,
    contingents: PropTypes.array.isRequired,
    availability: PropTypes.object.isRequired,
    inventory: PropTypes.object.isRequired
};
